const actions = {
  FETCH_STATUS_COUNT: 'FETCH_STATUS_COUNT',
  FETCH_STATUS_ERROR: 'FETCH_STATUS_ERROR', 
  FETCHING_STATUS: 'FETCHING_STATUS',
  FETCHED_STATUS: 'FETCHED_STATUS',
  RESET_FETCHED_STATUS: 'RESET_FETCHED_STATUS',

  fetchStatus: (payload) => ({
    type: actions.FETCH_STATUS_COUNT,
    payload: payload,
  }),
  resetFetchStatus: () => ({
    type: actions.RESET_FETCHED_STATUS,
  }),

  //
  

};
export default actions;
